import { Button as ChakraButton } from "@chakra-ui/react";
import React from "react";
interface IButton {
  children: React.ReactElement;
}

const Button = ({ children, ...props }: any) => {
  return (
    <ChakraButton _hover={{ bg: "" }} _focus={{ bg: "" }} {...props}>
      {children}
    </ChakraButton>
  );
};

export default Button;
